import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 登錄接口 
export const login = (params) => { return loginreq("post", "/api/client/login", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 用户管理 
 **/
// 用户管理-获取用户列表


export const userList = (params) => { return axios.get("/api/admin/user?status=" + params.status + "&telphone=" + params.telphone+ "&name=" + params.name) };
export const Recommend = (params) => { return axios.get("/api/module?mt_id="+params.mt_id+"&name=&limit=10000") };


export const guestBook = (params) => { return req("post", "/api/client/guestbook", params) };

export const order = (params) => { return axios.get("/api/client/order?status="+params.status+"&limit=15&client_id="+params.client_id+"&program_id="+params.program_id+"&page="+params.page+"&limit="+params.limit) };
export const edtUser = (params) => { return req("put", " /api/client/"+params.id,params) };

export const Working = (params) => { return axios.get("/api/client/month/time/list?datetime="+params.year+"-"+params.month+"&program_id="+params.program_id) };
export const dayWorking = (params) => { return axios.get("/api/client/day/time/list?datetime="+params.year+"-"+params.month+"-"+params.day+"&program_id="+params.program_id) };

export const program = (params) => { return axios.get("/api/client/program") };


export const orderSave = (params) => { return req("post", "/api/client/order", params) };

export const orderEdit = (params) => { return req("put", "/api/client/order/"+params.id, params) };

export const orderEel = (params) => { return req("put", "/api/client/order/cancel/"+params.id, params) };

export const userColor = (params) => { return axios.get("/api/admin/users?status=1") };

export const regSms = (params) => { return req("post", "/api/client/register/code", params) };

export const fgSms = (params) => { return req("put", "/api/client/repwd/code", params) };

export const rePwd = (params) => { return req("put", "/api/client/repwd", params) };


export const regUser = (params) => { return req("put", "/api/client/register", params) };

export const settings = (params) => { return axios.get("/api/module?limit=1000&mt_id=6&name="+params) };

export const cheaklogin = (params) => { return req("post", "/api/client/cheaklogin", params) };

export const heartbeat = (params) => { return axios.get("/api/client/heartbeat") };


// WEBPACK FOOTER //
// ./src/api/userMG.js